"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div `
    width: 50%;
    @media screen and ${constants_1.Device.tablet} {
        width: 75%;
    }
    @media screen and ${constants_1.Device.mobileL} {
        width: 100%;
    }
    .site-block {
        p {
            margin-bottom: 2em;
        }
    }
    .btn {
        display: block;
        margin: 0 auto;
    }
`;
//# sourceMappingURL=LoginRequiredStyled.js.map